export enum HappinessPagesInfoViewTexts {
  NoFlags = 'All good, no flags here',
  NoUnhappyResponses = 'No unhappy responses for this survey',
  NoResponsesWithSuchFilters = 'No responses matching these filters',
  NoResponsesAtAll = 'No responses for this survey',
}
